import axios from "axios";
import {
  getSessionData,
  removeSessionData,
} from "./app/components/base/helper/baseHelper";
import{GenerateAIMSToken} from "./app/components/base/helper/authHelper";
import { AIMS_BACKEND_URL } from "./app/constants/baseConstants";

const axiosInstance = axios.create({
  baseURL: AIMS_BACKEND_URL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const aimsadmintoken = getSessionData({ key: "aimsadmintoken" });
    config.headers.Authorization = aimsadmintoken
      ? `Bearer ${aimsadmintoken}`
      : "";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => Promise.resolve(response),
  async(error) => {
    if (!error.response) {
      return Promise.reject(error);
    }
    if (error.response.status === 403) {
      removeSessionData({ key: "aimsadmintoken" });
    } else if(error.response.status === 401) {
      var result = window.confirm("Session Expired, Do you want to create a new session ? ");
      if(result) {
        await GenerateAIMSToken();

        return new Promise(function(resolve, reject){
          const newConfig = error.config;
          const aimsadmintoken = getSessionData({ key: "aimsadmintoken" });
          newConfig.headers.Authorization = aimsadmintoken
          ? `Bearer ${aimsadmintoken}`
          : "";

          axios(newConfig).then((response)=>{
            resolve(response);
          })
          .catch((err)=>{
            reject(err);
          });
        })
      }
      else {
        return Promise.reject(error);
      }
    }
    else {
      return Promise.reject(error);
    }
  }
);

export default axiosInstance;